if ( typeof RecentlyViewedProducts !== 'function' ) {

  const RV_NAV_DOM = '<span class="css-slider-button css-slider-prev" style="display:none"><svg fill="none" height="13" viewBox="0 0 8 13" width="8" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m7.91419 1.41431-6.48529 6.48528-1.4142102-1.41422 6.4852802-6.48527702z"/><path d="m6.48528 12.9849-6.48528027-6.48532 1.41421027-1.41421 6.48528 6.48523z"/></g></svg></span><span class="css-slider-button css-slider-next" style="display:none"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.914169 11.5857L7.39945 5.10041L8.81367 6.51463L2.32838 12.9999L0.914169 11.5857Z" fill="black"/><path d="M2.34307 0.0151367L8.82835 6.50042L7.41414 7.91463L0.928857 1.42935L2.34307 0.0151367Z" fill="black"/></svg></span>';

  class RecentlyViewedProducts extends HTMLElement {

    constructor() {
      super();

      this.storageKey = 'homecare_recently_viewed';
      this.maxStored = 20;
      this.maxDisplay = parseInt(this.dataset.maxItems, 10) || 8;

      this.buttonStyle = this.dataset.buttonStyle || 'outline';
      this.alignBuy = this.dataset.alignBuy === 'true';
      this.textAlignment = this.dataset.textAlignment || 'left';
      this.textSize = this.dataset.textSize || 'xlarge';
      this.fit = this.dataset.fit === 'true';
      this.buyLabel = this.dataset.buyLabel || 'Buy now';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold Out';
      this.soldOutBg = this.dataset.soldOutBg || '';
      this.soldOutColor = this.dataset.soldOutColor || '';

      this.wrapper = this.querySelector('[data-rv-wrapper]');
      this.mount = this.querySelector('[data-rv-slider-mount]');

      const snapshotEl = this.querySelector('[data-rv-snapshot]');
      if ( ! snapshotEl || ! this.mount || ! this.wrapper ) return;

      let snapshot;
      try {
        snapshot = JSON.parse(snapshotEl.textContent);
      } catch(e) {
        return;
      }
      if ( ! snapshot || ! snapshot.handle ) return;

      const stored = this._recordVisit(snapshot);
      const items = stored.filter(item => item.handle !== snapshot.handle).slice(0, this.maxDisplay);

      if ( items.length === 0 ) return;

      this._render(items);

      this.style.display = '';
      this.wrapper.style.display = '';

    }

    _readStore() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch(e) {
        return [];
      }
    }

    _recordVisit(snapshot) {
      let stored = this._readStore();
      stored = stored.filter(item => item.handle !== snapshot.handle);
      stored.unshift(snapshot);
      stored = stored.slice(0, this.maxStored);
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(stored));
      } catch(e) {}
      return stored;
    }

    _render(items) {

      const sliderId = this.dataset.sliderId || 'css-slider-recently-viewed';
      const layoutClass = this.dataset.layoutClass || 'grid-4 grid-portable-3 grid-lap-2 grid-tiny-1';
      const cardsHtml = items.map(item => this._cardHTML(item)).join('');

      const options = JSON.stringify({
        selector: '.product-item',
        groupCells: true,
        indexNav: true,
        navigationDOM: RV_NAV_DOM
      });

      // Build the slider with its final content already in place so the
      // css-slider custom element measures the real item count on upgrade
      // (populating an already-upgraded/empty slider skips its drag/resize setup).
      this.mount.innerHTML = `
        <css-slider data-options='${options}' class="css-slider css-slider--bottom-navigation" id="${sliderId}">
          <div class="grid grid--slider ${layoutClass}">${cardsHtml}</div>
        </css-slider>
      `;

    }

    _cardHTML(item) {

      const ratio = item.aspectRatio > 0 ? item.aspectRatio : 1;
      const padding = (100 / ratio).toFixed(4);
      const title = this._escape(item.title);
      const url = this._escape(item.url);
      const image = this._escape(item.image);
      const useAjaxCart = window.KROWN && KROWN.settings && KROWN.settings.cart_action === 'overlay';

      let quickBuyHtml;

      if ( item.poa ) {
        quickBuyHtml = `
          <div class="product-item__quick-buy">
            <a href="${url}" class="button button--regular button--fullwidth button--outline">
              Enquire Now
            </a>
          </div>
        `;
      } else if ( item.available ) {
        quickBuyHtml = `
          ${this.alignBuy ? `</div><div class="product-item__text gutter--regular spacing--xlarge remove-empty-space text-align--${this.textAlignment}" style="padding-top: 0;">` : ''}
          <div class="product-item__quick-buy">
            <quick-add-to-cart class="quick-add-to-cart">
              <product-form ${useAjaxCart ? 'data-ajax-cart' : ''}>
                <div class="quick-add-to-cart-button">
                  <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" novalidate="novalidate">
                    <input type="hidden" name="id" value="${item.variantId}">
                    <button class="button button--${this.buttonStyle} button--regular button--fullwidth button--loader" data-js-product-add-to-cart type="submit" name="add">
                      <span class="button__text">${this._escape(this.buyLabel)}</span>
                      <span class="button__preloader">
                        <svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"/></svg>
                      </span>
                    </button>
                  </form>
                </div>
              </product-form>
            </quick-add-to-cart>
          </div>
        `;
      } else {
        quickBuyHtml = '';
      }

      return `
        <div class="product-item card" data-js-product-item>
          <a href="${url}" class="card__image product-item__image" style="padding-top:${padding}%">
            <figure class="lazy-image lazy-image--background lazy-image--animation ${this.fit ? 'lazy-image--fit' : ''}" data-ratio="${ratio}">
              <img src="${image}" alt="${title}" loading="lazy" class="img" data-ratio="${ratio}" onload="this.parentNode.classList.add('lazyloaded')">
            </figure>
          </a>
          <div class="card__text product-item__text gutter--regular spacing--xlarge remove-empty-space text-align--${this.textAlignment}">
            <a class="product-item__title" href="${url}" title="${title}">
              <div class="remove-line-height-space--small">
                <span class="text-animation--underline text-size--${this.textSize} text-line-height--small text-weight--bold text-animation--underline">${title}</span>
              </div>
            </a>
            <div class="product-item__price text-size--large equalize-white-space">
              <div class="remove-line-height-space">${item.priceHtml || ''}</div>
            </div>
            ${quickBuyHtml}
          </div>
          ${ ! item.poa && ! item.available ? `
            <div class="product-item__badges text-size--xsmall">
              <span class="product-item__badge product-item__badge--sold" style="background-color:${this.soldOutBg};color:${this.soldOutColor}">${this._escape(this.soldOutLabel)}</span>
            </div>
          ` : '' }
        </div>
      `;

    }

    _escape(str) {
      const div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

  }

  if ( typeof customElements.get('recently-viewed-products') == 'undefined' ) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

}
